import script from "./bv627.vue?vue&type=script&setup=true&lang=js"
export * from "./bv627.vue?vue&type=script&setup=true&lang=js"

import "./bv627.vue?vue&type=style&index=0&id=423635d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423635d3"]])

export default __exports__